import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { Link } from 'react-scroll';
import CtaButton from '../../components/CtaButton';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

class TypeWriter extends React.Component {
	componentDidMount() {		
		var elements = document.getElementsByClassName('typewrite');
		for (var i = 0; i < elements.length; i++) {
			var toRotate = elements[i].getAttribute('data-type');
			var period = elements[i].getAttribute('data-period');
			if (toRotate) {
				new TxtType(elements[i], JSON.parse(toRotate), period);
			}
		}		
	}
	render() {
		return (
			<span className="typewrite" data-period="2000" data-type='[ "visualized", "plans", "data", "structure", "history", "analytics"]'>
			</span>
		);
	}
}

var TxtType = function (el, toRotate, period) {
	this.toRotate = toRotate;
	this.el = el;
	this.loopNum = 0;
	this.period = parseInt(period, 10) || 2000;
	this.txt = '';
	this.tick();
	this.isDeleting = false;
};

TxtType.prototype.tick = function () {
	var i = this.loopNum % this.toRotate.length;
	var fullTxt = this.toRotate[i];

	if (this.isDeleting) {
		this.txt = fullTxt.substring(0, this.txt.length - 1);
	} else {
		this.txt = fullTxt.substring(0, this.txt.length + 1);
	}

	this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

	var that = this;
	var delta = 200 - Math.random() * 100;

	if (this.isDeleting) { delta /= 2; }

	if (!this.isDeleting && this.txt === fullTxt) {
		delta = this.period;
		this.isDeleting = true;
	} else if (this.isDeleting && this.txt === '') {
		this.isDeleting = false;
		this.loopNum++;
		delta = 500;
	}

	setTimeout(function () {
		that.tick();
	}, delta);
};

function WistiaPopup() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://charthop.wistia.com/medias/msgs17xs45'
							playing
							volume={1}
							controls={false}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const Overview = (props) => {

	const location = props.location;

	return (
		<Layout bodyClass="page-product-overview" ontouchstart>
			<SEO title="Product Overview | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta name="description" content="ChartHop - the only platform that integrates your Org Chart, People Analytics, Headcount Planning, Compensation Reviews and Performance Management all in one." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Product Overview | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="ChartHop - the only platform that integrates your Org Chart, People Analytics, Headcount Planning, Compensation Reviews and Performance Management all in one." />
				<meta property="og:image" content={`https://www.charthop.com/home/product-overview-meta.gif`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Product Overview | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="ChartHop - the only platform that integrates your Org Chart, People Analytics, Headcount Planning, Compensation Reviews and Performance Management all in one." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/product-overview-meta.gif`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

		{/* HERO CONTENT */}
		<section className="hero-formNoImage sectionSpacing">
			<div className="introContent">
				<div className="introTitle">
					<h1>Your people <TypeWriter /><span className="blinking-cursor">|</span></h1>
					<h1>- all in one place.</h1>
				</div>
				<DemoFormShort source="product-overview-demo-header" />
				<WistiaPopup />
			</div>
		</section>

		{/* PAGE NAVIGATION */}
		<section className="subNavigationMenu-Inline">
			<div>
				<div>
					<div>
						<Link to="org-chart" smooth={true} offset={-70} duration={500}>Org Chart</Link>
					</div>
					<div>
						/
					</div>
					<div>
						<Link to="analytics" smooth={true} offset={-70} duration={500}>Analytics</Link>
					</div>
					<div>
						/
					</div>
					<div>
						<Link to="planning" smooth={true} offset={-70} duration={500}>Planning</Link>
					</div>
					<div>
						/
					</div>
					<div>
						<Link to="performance" smooth={true} offset={-70} duration={500}>Performance</Link>
					</div>
				</div>
			</div>
		</section>

		{/* ORG CHART*/}
		<section className="sectionSpacing backgroundGradientContainer pt-5" id="org-chart">
			<div className="contentBlock">
				<p className="minorBlueHeader mb-lg-0">THE WORLD'S BEST ORG CHART</p>
				<div className="contentBlock">
					<MultimedialPanel 
						multimediaPosition="left"
						title="You've never seen an org chart like this before."
						link="/home/03_Time_Travel_04_Optimized.mp4"
						type="video"
						paddingClass="padding-top-video-1"
						content={
							<React.Fragment>
								<p>Sync up your existing people systems and get a single, dynamic, always-up-to-date view of all your people - without the manual work.
								</p>
								<p>Everything you'd expect in a world-class org chart:
								</p>								
								<div className="row">
									<p className="col-lg-6 col-md-12 col-sm-6 col-12 mb-0">
									<li>Automatic updates</li>
										<li>HRIS/PEO integrations</li>
										<li>Slack integration</li>
										<li>Fully searchable directory</li>
										<li>Custom employee profiles</li>
									</p>
									<p className="col-lg-6 col-md-12 col-sm-6 col-12 mb-0">
									<li>PowerPoint export</li>
										<li>Embeddable org chart</li>
										<li>Seamless navigation</li>
										<li>Indirect reporting lines</li>
										<li>Cross-functional teams</li>
									</p>
								</div>
							</React.Fragment>
						}
					/>
				</div>
				<h4 class="listTitle mt-0 text-center pt-3">Plus, capabilities you didn't even know were possible</h4>
				<div className="svg-info mt-xl-2">
					<div className="svg-info-card-3col">
						<img src={'/product-overview/icons/time-travel-icon.svg'} alt="Time Travel" />
						<h3 className="mb-0">Travel through time</h3>
						<p>Visualize your organization's evolution through the past and into the future. See or share an org chart from <strong>any</strong> point in time.</p>
					</div>
					<div className="svg-info-card-3col">
						<img src={'/product-overview/icons/illustrate-diversity-icon.svg'} alt="Diversity" />
						<h3 className="mb-0">Illustrate diversity</h3>
						<p>Spot biases early by visualizing your org structure through any dimension - gender, location, tenure, ethnicity, Myers-Briggs & more.</p>
					</div>
					<div className="svg-info-card-3col">
						<img src={'/product-overview/icons/align-plan-icon.svg'} alt="Adaptibility" />
						<h3 className="mb-0">Align on the plan</h3>
						<p>Visualize your hiring plan and finally have a source of truth. Display open roles, filled roles and everything in between. </p>
					</div>
				</div>
			</div>			

			<div class="contentBlock py-5">
				<div class="contentBlock">
					<div class="multimediaContainer-special row py-lg-5 align-items-center reverse">
						<div class="col-md-6  pr-md-2 pr-lg-4">
							<h2>New for distributed teams - visualize your remote team on the map!</h2>
							<p>"As the former leader of a team of nearly 800 people all over the world, the organizational picture that ChartHop can easily and quickly provide is something I wish I had had nearly every day.</p>
							<p>The immediate need for leaders to have visibility across their teams has only increased with remote work becoming the norm and having diverse teams that much more urgent.”</p>
							<div class="testimonyAuthor">
								<img src="/product-overview/headshots/ShannonBrayton_LinkedIn.jpeg" alt="foto"/>
								<div class="d-flex flex-column">
									<p class="my-0"><b> Shannon Brayton </b></p>
									<p class="my-0 minorBlueHeader text-left">Former CMO @ LinkedIn</p>
								</div>
							</div>
						</div>
						<div class="reactPlayerContainer col-md-6">
							<img class="shadow-and-radius" src="/product/org-chart/org-chart-panel-picture.png" alt="charthop"/>
						</div>
					</div>
				</div>
				<div class="pt-3">
					<div class="buttonContent">
						<center><a class="button" rel="noopener noreferrer" target="_blank" href={PATHS.ORG_CHART}>LEARN MORE</a></center>
					</div>
				</div>
			</div>

		</section>


		{/* ANALYTICS */}
		<section className="sectionSpacing py-5" id="analytics">
			<p className="minorBlueHeader mb-lg-0">THE MOST COMPREHENSIVE PEOPLE ANALYTICS</p>
			<div className="contentBlock">
				<MultimedialPanel 
					multimediaPosition="left"
					title="Finally, leverage people analytics as a catalyst for change."
					link="/product/people-analytics/Integration_reports-2.mp4"
					type="video"
					paddingClass="padding-top-video-2"
					content={
						<React.Fragment>
							<p>Answer any question with always-up-to-date, robust & custom reporting, no pivot tables necessary.</p><p>
							Give your team the context they need to make better decisions with centralized data, streamlined sharing and fine-grained access controls.
							</p>
						</React.Fragment>
					}
				/>		
			</div>
			<div className="mx-0 mt-0">
				<h4 class="listTitle mt-0 text-center pt-3">Meet your new analyst, providing you historical and point-in-time reports for whatever you need.</h4>
				<div className="flex-centeredColumn contentBlock text-center">
				<div className="pgc1 max-width-pgc1 display-block-pgc1 text-left">
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Diversity, equity &amp; inclusion</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Engagement &amp; retention</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Costs &amp; compensation</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img  className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Org design &amp; structure</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Board meeting decks</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Executive standups</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Recruiting updates</p>
						</div>
					</div>
					<div className="pgc2">
						<div className="pgc3">
							<img className="align-bullets" src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>All Hands meetings</p>
						</div>

					</div>
				</div>
				</div>
				<p class="subListTitle mb-0 font-weight-bold text-center pb-4">&amp; more</p>
				<CtaButton
					text="LEARN MORE"
					link={PATHS.PEOPLE_ANALYTICS} 
				/>
			</div>
		</section>

		{/* FIRST HEADCOUNT PLANNING */}
		<section className="sectionSpacing backgroundGradientContainer py-5" id="planning">
			<p className="minorBlueHeader mb-lg-0">THE FIRST HEADCOUNT PLANNING PLATFORM</p>
			<div className="contentBlock">
				<MultimedialPanel 
					multimediaPosition="right"
					title="Planning that puts people first."
					link="/landings/Scenario_RemoveOpenRole.gif"
					type="image"
					paddingClass="padding-top-video-3"
					content={
						<React.Fragment>
							<p>Provide the necessary context to create data-informed plans at every level of the organization - without the manual work.</p>
							<p>Collaborate on proposed changes, centralize approved changes across the org and track the budgetary & structural impact every step of the way.</p>
							<div className="row">
								<p className="col-lg-6 col-md-12 col-sm-6 col-12 mb-0">
									<li>Annual headcount plans</li>
									<li>Adhoc headcount adjustments</li>
									<li>Compensation plans</li>
									<li>Layoffs &amp; restructures</li>
								</p>
								<p className="col-lg-6 col-md-12 col-sm-6 col-12 mb-0">
									<li>Scaling plans</li>
									<li>M&amp;A integrations</li>
									<li>Contingency plans</li>
									<li>Succession plans</li>
								</p>
							</div>
						</React.Fragment>
					}
				/>

				<div className="svg-info mt-xl-2 padding-desktop-4">
					<div className="svg-info-card-1col half-card mt-lg-0">
						<img src={'/product-overview/icons/transparency_icon.svg'} alt="Transparency" />
						<h3 className="mb-0">Headcount Planning</h3>
						<p>Stop building proposed org charts in slides. Create thoughtful plans quickly using a first-of-its-kind drag and drop interface.</p>
					</div>
					<div className="svg-info-card-1col half-card mt-lg-0">
						<img src={'/product-overview/icons/notification_icon.svg'} alt="Notification" />
						<h3 className="mb-0">Compensation Reviews</h3>
						<p>Streamline your proposal and approval workflow. Forget the endless spreadsheets, the constant emails and the unnecessary confusion.</p>
					</div>
				</div>
				<CtaButton
					text="LEARN MORE"
					link={PATHS.PLANNING} 
				/>
			</div>
		</section>

		{/* PERFORMANCE REVIEWS */}
		<section className="sectionSpacing py-5" id="performance">
			<p className="minorBlueHeader mb-lg-0">THE ONLY INTEGRATED PERFORMANCE REVIEWS</p>
			<div className="contentBlock">
				<MultimedialPanel 
					multimediaPosition="left"
					title="Performance reviews that impact company performance."
					link="/product/performance/perf-review-questions.png"
					type="image"
					paddingClass="padding-top-video"
					content={
						<React.Fragment>
							<p>Build the processes, questions, approval flows and access controls you need to drive your business foward</p><p>
							Put performance data in context to make more thoughtful, unbiased, data-informed decisions about compensation, promotions, and hiring - all in one place.
							</p>
						</React.Fragment>
					}
				/>
			</div>
			<div className="sectionSpacing-Margin mx-0 mt-0">
				<h4 className="listTitle mt-0 text-center pt-3">Everything you need to manage your team</h4>
				<div className="flex-centeredColumn contentBlock text-center">
				<div className="pgc1 display-block-pgc1" style={{maxWidth:"670px"}}>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Formal reviews</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>360 reviews</p>
							</div>
						</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Informal feedback</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>Engagement surveys</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>KPI definition</p>
						</div>
					</div>
					<div className="pgc2-2">
						<div className="pgc3">
							<img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
							<p>1:1 tracking</p>
						</div>
					</div>
				</div>
				</div>
				<p class="subListTitle mb-0 font-weight-bold text-center">&amp; more</p></div>
				<CtaButton
					text="LEARN MORE"
					link={PATHS.PERFORMANCE} 
				/>
		</section>

		{/* DATA & SECURITY */}
		<section className="sectionSpacing backgroundGradientContainer py-5">
			<div className="contentBlock">
				<div>
					<div className="row align-items-center">
						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2">Your data is safe with us.</h2>
							<div className="text-center d-block d-md-none d-block mr-auto ml-auto">
								<img src='/home/safety.svg' alt="" width="195" />
							</div>
							<div className="container d-sm-flex pb-2">
								<ul className="col-md-6 pb-0 pr-3">
									<li>Encryption at rest & in transit</li>
									<li>Complete SOC 2 Type 2 Examination</li>
									<li>Mandatory SSO</li>
								</ul>
								<ul className="col-md-6 pt-0 pr-3">
									<li>Employee auto-offboarding</li>
									<li>Biometric access control</li>
									<li>Audit trails</li>
								</ul>
							</div>
							<a href={PATHS.SECURITY} target="_blank" className="ctaStandard"> Learn more </a>
						</div>
						<div className="col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/safety.svg' alt="" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>	
			</div>
		</section>

		{/* LONG FORM */}
		<section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
			<DemoFormLong source={"product-overview-demo-bottom"} headertext={HtmlParser("<h2>Hop to the future of your organization!<br/><br/>Request a demo.</h2>")} />
		</section>
		</Layout>
	);
};

export default Overview;
